module.exports = __webpack_public_path__ + "static/logo-24aabadda6f72c133f33378c10cc1c15.png";